export const profileViewTypes = {
    getProfile: '[PROFILE VIEW] Get profile',
}